export const getUserWishlistListId = (userId: number) =>
  `user-${userId}-wishlist`;
